import "./Footer.css";

import React from 'react'
import { FaGithub, FaHome, FaInstagram, FaLinkedin, FaMailBulk, FaPhone } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
            <div className="location">
                <FaHome size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                <div>
                    <p> Srinagar</p>
                    <p> Jammu & Kashmir, 190009</p>
                </div>
            </div>
            <div className="phone">
                <h4>
                <FaPhone size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                +91 - 9149765292
                </h4>    
            </div>
            <div className="mail">
                <h4>
                <FaMailBulk size={20} style={{color:"#fff", marginRight:"2rem"}}/>
                moudisajan@gmail.com
                </h4>
            </div>
        </div>
        <div className="right">
            <h4>MOUDISA JAN</h4>
            <h5>Proficient in Web Development, UX designing coupled with AWS and Java expertise. 
            I thrive in creating engaging digital experiences that seamlessly blend form and function.</h5>
            <div className="social">
              <Link to='https://www.instagram.com/moudisajan?igsh=ZTF4a29iZzduemE1'>
                <FaInstagram size={25} style={{color:"#fff", marginRight:"1.5rem"}}/>
              </Link>
              <Link to='https://www.github.com/Moudisa'>
                <FaGithub size={25} style={{color:"#fff", marginRight:"1.5rem"}}/>
              </Link> 
              <Link to='https://www.linkedin.com/in/moudisa-jan-498795165'>
                <FaLinkedin size={25} style={{color:"#fff", marginRight:"1.5rem"}}/>
              </Link> 
            </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
